import moment from 'moment';
import { ActionButton } from '../../components/vertical-dot/popper';
import { DATE_FORMAT } from '../common';
import { TableBodyCellColumn } from '../style/table.styled';

export const GrantAcceptanceTemplateHeader = ({
  actions,
  tableActions,
}: {
  actions?: any;
  tableActions?: any;
}): any[] => {
  const getActions = (rowData: Record<string, string>): any => {
    const newActions = tableActions;
    // if (rowData.status === 'Pending') {
    //   newActions = actions.filter((item: any) => item.action !== 'View Comments');
    // } else if (rowData.status === 'Approved') {
    //   newActions = actions.filter((item: any) => ['Edit', 'View'].includes(item.action));
    // } else if (rowData.status === 'Rejected') {
    //   newActions = actions.filter((item: any) => ['View Comments', 'View'].includes(item.action));
    // } else {
    //   newActions = actions;
    // }

    // if (rowData.isDefaultAdmin) {
    //   newActions = actions.filter((item: any) => ['View'].includes(item.action));
    // }
    return newActions;
  };
  const newActions = [
    ...(actions || []),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      Cell: ({ row }: any) => {
        return (
          <td>
            <ActionButton
              actions={getActions(row.original)}
              id={row.original.id}
              rowData={row.original}
              counter={parseInt(row?.id)}
            />
          </td>
        );
      },
    },
  ];

  return newActions;
};
